import client from "./client";

export default {
  get(params) {
    let query = "?";
    Object.keys(params).forEach((k) => {
      query += k + "=" + params[k] + "&";
    });
    return client.get(`client/` + query);
  },
  create(body) {
    return client.post(`client/`, body);
  },
  edit(body) {
    return client.put(`client/`, body);
  },
  delete(id) {
    return client.delete(`client/` + id);
  },
};



// WEBPACK FOOTER //
// ./src/apiServices/clientService.js